import Reflux from 'reflux';
import { PageActions, CourseActions } from 'actions';
import SteelCompass from 'services/SteelCompass';

var PageStore = Reflux.createStore({
  listenables: [PageActions],
  data: {
    courseHasQuiziframe: false,
  },
  getInitialState() {
    return this.data;
  },
  init() {},
  findById(id) {
    return SteelCompass.request('page', 'findById', { id });
  },
  checkForQuiziframe(pageIds) {
    const findPagesByIdPromises = pageIds.map(id => this.findById(id));

    Promise.all(findPagesByIdPromises).then(
      data => {
        const doesCourseHasQuiziframe = data.some(item => (
          item.pageRows
            .map(row => row.pageModules[0].type.name)
            .some(type => type === 'quiziframe')
        ));

        if (doesCourseHasQuiziframe) {
          this.data.courseHasQuiziframe = true;

          this.trigger(this.data);
        }
      },
      error => {
        console.log(error);
        CourseActions.genericError(error);
      }
    );
  },
});

export default PageStore;



// WEBPACK FOOTER //
// ./src/js/stores/Page.js